import React from "react";
import BasicInformation from "./BasicInformation/BasicInformation";
import Pictures from "./Documents/Pictures";
import Videos from "./Documents/Videos";
import StakeholderDocuments from "./Documents/Stakeholder";
import Others from "./Documents/Others";
import DevP3AlternativeCost from "./Development/DevP3AlternativeCost/DevP3AlternativeCost";
import DevP3BpscCost from "./Development/DevP3BpscCost/DevP3BpscCost";

import AADT from "./AADT/AADT";
import Cost from "./Cost/Cost";
import Stakeholder from "./Stakeholder/Stakeholder";
import Contract from "./Contract";
import ContractATC from "./Contract/ContractATC";
import ContractClaim from "./Contract/ContractClaim";
//#insert Point: import module
import DevEnvironmentReview from "./Development/DevEnvironmentReview";
import DevFeisCostEstimate from "./Development/DevFeisCostEstimate";
import ContractQualityAssurance from "./Contract/ContractQualityAssurance";
import ContractChangeOrder from "./Contract/ContractChangeOrder";
import ContractWorkZone from "./Contract/ContractWorkZone";
import ContractDBE from "./Contract/ContractDBE";
import News from "./News/News";

import "./ProjectModal.scss";

import {
  Container,
  Sidenav,
  Nav,
  Dropdown,
  Icon,
  Content,
  Sidebar,
  Button
} from "rsuite";

/*const panelStyles = {
  padding: "15px 20px",
  color: "#aaa"
};*/

/*const headerStyles = {
  padding: 20,
  fontSize: 16,
  background: "#34c3ff",
  color: " #fff"
};*/

class ProjectModal extends React.Component {
  state = {
    currentTab: "basic_info"
  };

  render() {
    const role = localStorage.getItem("project_role");
    let shownItem = this.props.projectItems.find(
      a => a.project_id === this.props.currentProjectID
    );
    let disabled = true;

    if (shownItem) {
      disabled =
        shownItem.data_status &&
        (shownItem.data_status.name === "Submitted" ||
          (shownItem.data_status.name === "Published" &&
            role !== "ROLE_MEMBER"));
    } else {
      disabled = false;
    }

    let mainBody = (
      <BasicInformation
        draft={this.props.basicInfoDraft}
        submit={this.props.basicInfoSubmit}
        updatePublished={this.props.basicInfoPublishedUpdate}
        updateDraft={this.props.basicInfoDraftUpdate}
        updateDraftAndSubmit={this.props.basicInfoDraftUpdateAndSubmit}
        auditBasicInfo={this.props.basicInfoAudit}
        unpublish={this.props.basicInfoUnpublish}
        projectItems={this.props.projectItems}
        currentProjectID={this.props.currentProjectID}
        disabled={disabled}
      />
    );

    if (this.state.currentTab === "basic_info") {
      mainBody = (
        <BasicInformation
          draft={this.props.basicInfoDraft}
          submit={this.props.basicInfoSubmit}
          updatePublished={this.props.basicInfoPublishedUpdate}
          updateDraft={this.props.basicInfoDraftUpdate}
          updateDraftAndSubmit={this.props.basicInfoDraftUpdateAndSubmit}
          auditBasicInfo={this.props.basicInfoAudit}
          unpublish={this.props.basicInfoUnpublish}
          projectItems={this.props.projectItems}
          currentProjectID={this.props.currentProjectID}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "doc_pictures") {
      mainBody = (
        <Pictures
          currentProjectID={this.props.currentProjectID}
          fetch={this.props.documents.fetch}
          add={this.props.documents.add}
          update={this.props.documents.update}
          delete={this.props.documents.delete}
          documents={this.props.documents.documents}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "doc_videos") {
      mainBody = (
        <Videos
          currentProjectID={this.props.currentProjectID}
          fetch={this.props.documents.fetch}
          add={this.props.documents.add}
          update={this.props.documents.update}
          delete={this.props.documents.delete}
          documents={this.props.documents.documents}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "doc_stakeholders") {
      mainBody = (
        <StakeholderDocuments
          currentProjectID={this.props.currentProjectID}
          fetch={this.props.documents.fetch}
          add={this.props.documents.add}
          update={this.props.documents.update}
          delete={this.props.documents.delete}
          documents={this.props.documents.documents}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "doc_others") {
      mainBody = (
        <Others
          currentProjectID={this.props.currentProjectID}
          fetch={this.props.documents.fetch}
          add={this.props.documents.add}
          update={this.props.documents.update}
          delete={this.props.documents.delete}
          documents={this.props.documents.documents}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "cost") {
      mainBody = (
        <Cost
          currentProjectID={this.props.currentProjectID}
          methods={this.props.cost}
          items={this.props.cost.cost}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "aadt") {
      mainBody = (
        <AADT
          currentProjectID={this.props.currentProjectID}
          aadt={this.props.aadt}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "stakeholders") {
      mainBody = (
        <Stakeholder
          currentProjectID={this.props.currentProjectID}
          stakeholder={this.props.stakeholder}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "dev_alter_cost") {
      mainBody = (
        <DevP3AlternativeCost
          items={this.props.devP3AlternativeCost.cost}
          methods={this.props.devP3AlternativeCost}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "dev_bpsc_cost") {
      mainBody = (
        <DevP3BpscCost
          items={this.props.devP3BpscCost.cost}
          methods={this.props.devP3BpscCost}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "news") {
      mainBody = (
        <News
          currentProjectID={this.props.currentProjectID}
          news={this.props.news}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "contract_basic_info") {
      mainBody = (
        <Contract
          contract={this.props.contract}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "contract_atc") {
      mainBody = (
        <ContractATC
          contractATC={this.props.contractATC}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "contract_claim") {
      mainBody = (
        <ContractClaim
          contractClaim={this.props.contractClaim}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "contract_dbe") {
      mainBody = (
        <ContractDBE
          contractDBE={this.props.contractDBE}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "contract_work_zone") {
      mainBody = (
        <ContractWorkZone
          contractWorkZone={this.props.contractWorkZone}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "contract_change_order") {
      mainBody = (
        <ContractChangeOrder
          contractChangeOrder={this.props.contractChangeOrder}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "contract_quality_assurance") {
      mainBody = (
        <ContractQualityAssurance
          contractQualityAssurance={this.props.contractQualityAssurance}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "dev_feis_estimate_cost") {
      mainBody = (
        <DevFeisCostEstimate
          devFeisCostEstimate={this.props.devFeisCostEstimate}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    } else if (this.state.currentTab === "dev_enviornment_review") {
      mainBody = (
        <DevEnvironmentReview
          devEnvironmentReview={this.props.devEnvironmentReview}
          currentProjectID={this.props.currentProjectID}
          toggleSmallModalHandler={this.props.toggleSmallModalHandler}
          showSmallModal={this.props.showSmallModal}
          disabled={disabled}
        />
      );
    }

    //#insert Point: add tab

    //     <Procurement
    //         currentProjectID={this.props.currentProjectID}
    //         methods={this.props.procurement}
    //         currentProcurement={this.props.procurement.procurement}
    //     />,

    //     <DBE
    //         currentProjectID={this.props.currentProjectID}
    //         dbe={this.props.dbe}
    //         toggleSmallModalHandler={this.props.toggleSmallModalHandler}
    //         showSmallModal={this.props.showSmallModal}/>,

    /*const headerStyles = {
      padding: 18,
      fontSize: 16,
      height: 56,
      background: "#34c3ff",
      color: " #fff",
      whiteSpace: "nowrap",
      overflow: "hidden"
    };*/

    /*const iconStyles = {
      width: 56,
      height: 56,
      lineHeight: "56px",
      textAlign: "center"
    };*/

    return (
      <div className={"ProjectModal"}>
        <Container>
          <Sidebar
            style={{ display: "flex", flexDirection: "column" }}
            collapsible
          >
            <Button onClick={this.props.closeModal}>
              <b>
                <Icon size={"1x"} icon="arrow-circle-o-left" /> Back to Project
                List
              </b>
            </Button>

            <Sidenav
              defaultOpenKeys={["3"]}
              defaultActiveKey="2"
              appearance="subtle"
              onSelect={eventKey => {
                this.setState({
                  currentTab: eventKey
                });
              }}
            >
              <Sidenav.Body>
                <Nav>
                  <Nav.Item
                    eventKey="basic_info"
                    icon={<Icon icon="dashboard" />}
                  >
                    Basic Information
                  </Nav.Item>
                  <Dropdown
                    eventKey="documents"
                    title="Files"
                    icon={<Icon icon="file" />}
                    disabled={!this.props.currentProjectID}
                  >
                    {/*<Dropdown.Item divider />*/}
                    {/*<Dropdown.Item panel style={panelStyles}>*/}
                    {/*Reports*/}
                    {/*</Dropdown.Item>*/}
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="doc_others"
                    >
                      Documents
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="doc_pictures"
                    >
                      Pictures
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="doc_videos"
                    >
                      Videos
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="doc_stakeholders"
                    >
                      Stakeholder
                    </Dropdown.Item>
                  </Dropdown>
                  <Nav.Item
                    disabled={!this.props.currentProjectID}
                    eventKey="cost"
                    icon={<Icon icon="money" />}
                  >
                    Cost
                  </Nav.Item>

                  <Nav.Item
                    disabled={!this.props.currentProjectID}
                    eventKey="stakeholders"
                    icon={<Icon icon="people-group" />}
                  >
                    Stakeholders
                  </Nav.Item>

                  <Dropdown
                    disabled={!this.props.currentProjectID}
                    eventKey="dev"
                    title="Development"
                    icon={<Icon icon="magic" />}
                  >
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="dev_alter_cost"
                    >
                      Alternative Cost
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="dev_bpsc_cost"
                    >
                      BPSC Cost
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="dev_feis_estimate_cost"
                    >
                      FEIS Estimate Cost
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="dev_enviornment_review"
                    >
                      Environment Review
                    </Dropdown.Item>
                  </Dropdown>

                  <Dropdown
                    disabled={!this.props.currentProjectID}
                    eventKey="contract"
                    title="Contract"
                    icon={<Icon icon="pencil" />}
                  >
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="contract_basic_info"
                    >
                      Basic Info
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="contract_dbe"
                    >
                      DBE
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="contract_atc"
                    >
                      ATC
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="contract_change_order"
                    >
                      Change Order
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="contract_claim"
                    >
                      Claim
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="contract_quality_assurance"
                    >
                      Quality Assurance
                    </Dropdown.Item>
                    <Dropdown.Item
                      disabled={!this.props.currentProjectID}
                      eventKey="contract_work_zone"
                    >
                      Work Zone
                    </Dropdown.Item>
                  </Dropdown>

                  <Nav.Item
                    disabled={!this.props.currentProjectID}
                    eventKey="news"
                    icon={<Icon icon="newspaper-o" />}
                  >
                    News
                  </Nav.Item>
                </Nav>
              </Sidenav.Body>
            </Sidenav>
          </Sidebar>

          <Container>
            <Content>{mainBody}</Content>
          </Container>
        </Container>
      </div>
    );
  }
}

export default ProjectModal;
